<div class="overlay-wrapper">
  <div class="blur-container">
    <div class="overlay" *ngIf="!showFullImage" [style.backgroundImage]="'url(\'' + placeholder + '\')'"></div>
  </div>
</div>
<div [class.hidden]="!showFullImage" style="z-index: 10">
  <ng-content />
</div>
